import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/auth';

const AdminRoute = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Verificar si hay token
        const hasToken = authService.isAuthenticated();
        
        if (!hasToken) {
          setIsAuthorized(false);
          setIsLoading(false);
          return;
        }

        // Verificar usuario y rol
        const user = await authService.getCurrentUserFromBackend();
        
        if (user && user.role === 'admin') {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
        }
      } catch (error) {
        console.error('Error verificando autorización:', error);
        setIsAuthorized(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white text-lg">Cargando...</div>
      </div>
    );
  }

  if (!isAuthorized) {
    // Verificar si está autenticado pero no es admin
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        // Si está autenticado pero no es admin, redirigir a su dashboard
        if (user.role === 'cliente' || user.role === 'tienda') {
          return <Navigate to="/home" replace />;
        }
      } catch (error) {
        // Error parsing, redirigir al login
      }
    }
    // Si no está autenticado o no tiene permisos, redirigir al login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminRoute;

